import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { Literals } from '../literals';

@Injectable({
  providedIn: 'root'
})
export class OrganisationService {

  constructor(private rest:RestService) { }

  public getCodeLinkageFieldsNamesByUserOrg(userName: string): any {
    return this.rest.get("getCodeLinkageFieldsNamesByUserOrg", userName);
  }

    public getUserAssignedLicenses(userName: string): any {
    return this.rest.get("getUserAssignedLicenses", userName);
  }

   public executionQuotaAvailable(projectId: any, licenseId: any, executionType: any, isDB2: any): any {
    let request = {
      project: { _id: projectId },
      licenseId: licenseId,
      executionType: executionType,
      isDB2: isDB2
    };
    return this.rest.post(Literals.EXECUTION_QUOTA_AVAILABLE, request);
  }
  
}
